<div class="main">
  <link href="https://fonts.googleapis.com/css2?family=Jost:wght@900&display=swap" rel="stylesheet"> 
  <div class="info-bar">

    <h1 class="">TIC<br>TAC<br>TOE</h1>
    {#each player_keys as player}
    <span class="inline">
      {#if player === current_player}
        <img src="icon-arrow.png" class="arrow" alt="arrow">
      {/if}
      <h3 class:active="{ player === current_player }">{players[player]}</h3>
      {#if winner == player}
      <img src="icon-crown.png" class="arrow" alt="crown">
      {/if}
    </span>
    {/each}
    {#if current_state === 'stopped'}
      {#if waiting === true}
        <h4> Waiting for <br>other players <br>to join.</h4>
      {/if}
    {/if}
    {#if show_scores}
    <span class="inline">
      <h3>{computed_scores[0]}</h3>
      {#if computed_scores[0] > computed_scores[1]}
        <img src="icon-crown.png" class="arrow" alt="crown">
      {/if}
    </span>
    <h4>Your score</h4>
    <span class="inline">
      <h3>{computed_scores[1]}</h3>
      {#if computed_scores[1] > computed_scores[0]}
        <img src="icon-crown.png" class="arrow" alt="crown">
      {/if}
    </span>
    <h4>{players[other_player]}</h4>
    {/if}
  <button class="button is-link" on:click={reset}>Restart?</button>
</div>
  <div class="map-outer">
    <div class="map">
      {#each board as line, i}
        {#each line as square, j}
        <div class="content" id="map" on:click={() => { move(i, j) }}>
          {#if square === 1}
            <p class="squ animate__animated animate__bounceIn">X</p>
          {:else if square === 2}
            <p class="squ animate__animated animate__bounceIn">O</p>
          {:else}
            <p class="squ animate__animated animate__bounceIn"></p>
          {/if}
        </div>
        {/each}
      {/each}
    </div>
  </div>
  
</div>

<script>
import { time_ranges_to_array } from 'svelte/internal';
import { push } from 'svelte-spa-router'
import 'animate.css'

export let params = {}

import name_store from './name_store'

function get__store(store) {
  let $val
  store.subscribe($ => $val = $)()
  return $val
}

let name = get__store(name_store)


let own_id = ''
let waiting = true
let users = {}
let players = {}
$: player_keys = Object.keys(players)
let current_player = ''
let other_player = ''
let current_state = 'stopped'
let winner = ''
let scores = []
let computed_scores = [0, 0]
let tie = false
let show_scores = false
let board = [[0, 0, 0], [0, 0, 0], [0, 0, 0]]

if(name === "") {
  name = prompt("Enter your nickname")
  if(name === null || name == "") {
  name = 'RickAstley'
}
}

let websocket = new WebSocket(`wss://tic-tac-toe-online-backend.herokuapp.com/ws?name=${name}&id=${params.id}`)

const compute_scores = (scores) => {
  let own_wins = 0
  let other_wins = 0
  for(let i = 0; i < scores.length; i++) {
    if(scores[i] === own_id) { own_wins += 1 }
    else { other_wins += 1 }
  }
  return [own_wins, other_wins]
}

websocket.onmessage = (message) => {
  let res = JSON.parse(message.data)
  switch(res.EventType) {
    case 'info':
      own_id = res.EventData.id
      users[res.EventData.id] = res.EventData.name
      break
    case 'join':
      users[res.EventData.id] = res.EventData.name
      break
    case 'players':
      for(const [k, v] of Object.entries(res.EventData)) {
        if(k !== own_id) { other_player = k }
        if(v.length > 10) { 
          let tmp = v
          tmp = tmp.slice(0, 9)
          tmp += '..'
          res.EventData[k] = tmp
        }
      }
      players = res.EventData
      break
    case 'start':
      waiting = false
      current_state = 'started'
      tie = false
      winner = ''
      current_player = res.EventData.current_user
      break
    case 'board':
      board = res.EventData
      break
    case 'currentuser':
      current_player = res.EventData
      break
    case 'scores':
      show_scores = true
      computed_scores = compute_scores(res.EventData)
      break
    case 'disconnect':
      if(res.EventData in players) {
        delete players[EventData]
      }
      if(res.EventData === other_player) {
        other_player = ''
        waiting = true
      }
      break
    case 'win':
      current_state = 'stopped'
      winner = res.EventData
      break
    case 'tie':
      current_state = 'stopped'
      tie = true
      break
  }
} 


websocket.onclose = () => {
  push('/notfound')
}

const reset = () => {
  websocket.send(JSON.stringify({
    MessageType: 'reset',
    MessageData: {}
  }))
}

const move = (x, y) => {
  websocket.send(JSON.stringify({
    MessageType: 'move',
    MessageData: {
      X: x,
      Y: y
    }
  }))
}

</script>


<style>
h1 {
  color: #ffffff;
  
  text-transform: uppercase;
  font-size: 4em;
  font-weight: 900;
  font-family: 'Jost', sans-serif;

  line-height: 80%;
}

h3 {
  color: white;

  font-size: 3em;
  font-weight: 900;
  font-family: 'Jost', sans-serif;
}
:global(h4) {
  color: grey;

  font-size: 2.5em !important;
  font-weight: 900;
  font-family: 'Jost', sans-serif;
  margin-top: -10px !important;
}

.squ{
  font-size: 3em;
  font-weight: 900;
  font-family: 'Jost', sans-serif;
}
.main {
  display: flex;
  flex-direction: column;
}

:global(html){
		background-color: rgb(26, 26, 26) !important;
}
.inline {
  display: flex;
  align-items: center;

}

.map-outer {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.arrow {
  width: 3em;
  height: 3em;
}
.map {
  outline: 10px solid rgb(26, 26, 26);
  outline-offset: -10px;
  text-align: center;
  width: 50vw;
  height: 50vw;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 0px 0px;
  grid-template-areas:
    ". . ."
    ". . ."
    ". . .";
}

.info-bar {
  position: absolute;
  margin-top: 20px;
  margin-left: 20px;
}

.info-bar > * {
  margin-top: 20px;
}

.info-bar .active {
  color: #237FFF;
}

.content {
  font-size: 2em;
  padding-top: 20%;color: white;
  color: #fff;
  border: 3px solid white;
  margin-bottom: 0 !important;
}

.content:hover{
  background-color: rgb(44, 44, 44);
}

p {
  color: white;
  font-size: 13px;
}

@media (max-width: 1000px) {
  .info-bar{
    position: static;
  }

  .map {
    width: 100vw;
    height: 100vw;
  }
  .squ{
    font-size: 1.9em;
    font-weight: 900;
    font-family: 'Jost', sans-serif;
  }
}
	@media (prefers-color-scheme: light) {
		p, h3, h1 {
      color: black;
    }

    h4 {
      color:rgb(44, 44, 44);
    }

    .content {
      padding-top: 20%;color: black;
      color: black;
      border: 3px solid black;
    }

    .content:hover{
      background-color: rgb(185, 185, 185);
    }

    :global(html){
		background-color: rgb(255, 255, 255) !important;
    }

    .map {
      outline: 10px solid rgb(255, 255, 255);
	  }

    .main {
      background-color: white;
    }
  }

</style>